export const pleatTypeContent = `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
    <style>
        .type-of-fold .heading {
            text-align: center;
            margin-bottom: 30px;
        }

        .type-of-fold .heading h4 {
            font-size: 20px;
            margin: 0 0 16px;
            padding: 0 0 16px;
            border-bottom: 1px solid #efefef;
        }

        .type-of-fold .row {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
        }

        .type-of-fold-item h5 {
            margin: 0 0 24px;
            font-size: 18px;
        }

        .type-of-fold-item img {
            width: 100%;
            vertical-align: middle;
            height: auto;
            margin: 0 0 30px;
        }

        .type-of-fold-item p {
            margin: 0 0 16px;
        }

        .type-of-fold-item p:last-child {
            margin: 0;
        }

        .type-of-fold-item a {
            text-decoration: underline;
            color: inherit;
        }

        @media (max-width: 767px) {
            .type-of-fold .row {
                grid-template-columns: 1fr;
            }
        }
    </style>
</head>

<body>
    <div class="type-of-fold">
        <div class="heading">
            <h4>Type of Fold</h4>
            <p>Select your desired pleat finish here. The curtain can be finished with three different pleats at the
                top.</p>
        </div>
        <div class="row">
            <div class="type-of-fold-item">
                <h5>Single pleat</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/singleplete_1759322871313.png?v=1759753620" alt="Single pleat curtain">
                <p>A curtain with a single pleat gives your interior a sleek and calming look. If your ceiling is lower
                    than 180 cm, the wave of the pleat will still fall beautlifully to the floor. A single pleat
                    requires less fabric than double pleat, creating compact fabric package when the curtains are open.
                </p>
            </div>
            <div class="type-of-fold-item">
                <h5>Double pleat (butterfly pleat)</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/doubleplete_1759322871024.png?v=1759753620" alt="Double pleat curtain">
                <p>A curtain with a double pleat, also known as butterfly pleat, gives your interior a chic look. If
                    your ceiling is higher than 180 cm, the pleat will extend beautlifully to the bottom edge of the
                    fabric. A double pleat uses more fabric than a single pleat, giving the curtain a rich and full
                    look.</p>
            </div>
            <div class="type-of-fold-item">
                <h5>Wave pleat</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/wavepleate_1759322871373.png?v=1759753620" alt="Wave pleat curtain">
                <p>A curtain with a wave pleat gives your interior a modern look. A wave curtain hangs in a wave pattern
                    under the rail. This is thanks to a system of wave runners connected a cord.</p>
                <p>Tip 1:For a wave pleat, you need a wide gauge rail with a glider distance of 8 cm.</p>
                <p>Tip 2:A wave pleat can create gaps at the top, making a single or double pleat more suitable for
                    rooms that you want to completely darken.</p>
                <p>Unsure about the <a href="#">different curtain pleats?</a> your personal advisor is ready to help!
                    Schedule a <a href="#">free consultation</a> and get advice on the best option for your window.</p>
            </div>
        </div>
    </div>
</body>

</html>`;
